package com.tovtalk.database

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Double
import kotlin.Long
import kotlin.String

public class UserQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> getUserById(id: Long, mapper: (
    id: Long,
    firebaseUid: String,
    identity: String,
    fullname: String,
    username: String,
    email: String?,
    profilePhoto: String?,
    bio: String?,
    followerCount: Long,
    followingCount: Long,
    totalPostLikesCount: Long,
    coinWallet: Long,
    coinCollectedLifetime: Long,
    coinGiftedLifetime: Long,
    coinPurchasedLifetime: Long,
    isVerified: Long,
    isFreeze: Long,
    isReadOnly: Long,
    isModerator: Long,
    appLanguage: String,
    whoCanViewPost: Long,
    showMyFollowing: Long,
    receiveMessage: Long,
    notifyPostLike: Long,
    notifyPostComment: Long,
    notifyFollow: Long,
    notifyMention: Long,
    notifyGiftReceived: Long,
    notifyChat: Long,
    country: String?,
    countryCode: String?,
    region: String?,
    city: String?,
    lat: Double?,
    lon: Double?,
    isFollowing: Long,
    followStatus: Long,
    isBlocked: Long,
    createdAt: String,
    updatedAt: String,
    appLastUsedAt: String?,
  ) -> T): Query<T> = GetUserByIdQuery(id) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15)!!,
      cursor.getLong(16)!!,
      cursor.getLong(17)!!,
      cursor.getLong(18)!!,
      cursor.getString(19)!!,
      cursor.getLong(20)!!,
      cursor.getLong(21)!!,
      cursor.getLong(22)!!,
      cursor.getLong(23)!!,
      cursor.getLong(24)!!,
      cursor.getLong(25)!!,
      cursor.getLong(26)!!,
      cursor.getLong(27)!!,
      cursor.getLong(28)!!,
      cursor.getString(29),
      cursor.getString(30),
      cursor.getString(31),
      cursor.getString(32),
      cursor.getDouble(33),
      cursor.getDouble(34),
      cursor.getLong(35)!!,
      cursor.getLong(36)!!,
      cursor.getLong(37)!!,
      cursor.getString(38)!!,
      cursor.getString(39)!!,
      cursor.getString(40)
    )
  }

  public fun getUserById(id: Long): Query<UserEntity> = getUserById(id) { id_, firebaseUid,
      identity, fullname, username, email, profilePhoto, bio, followerCount, followingCount,
      totalPostLikesCount, coinWallet, coinCollectedLifetime, coinGiftedLifetime,
      coinPurchasedLifetime, isVerified, isFreeze, isReadOnly, isModerator, appLanguage,
      whoCanViewPost, showMyFollowing, receiveMessage, notifyPostLike, notifyPostComment,
      notifyFollow, notifyMention, notifyGiftReceived, notifyChat, country, countryCode, region,
      city, lat, lon, isFollowing, followStatus, isBlocked, createdAt, updatedAt, appLastUsedAt ->
    UserEntity(
      id_,
      firebaseUid,
      identity,
      fullname,
      username,
      email,
      profilePhoto,
      bio,
      followerCount,
      followingCount,
      totalPostLikesCount,
      coinWallet,
      coinCollectedLifetime,
      coinGiftedLifetime,
      coinPurchasedLifetime,
      isVerified,
      isFreeze,
      isReadOnly,
      isModerator,
      appLanguage,
      whoCanViewPost,
      showMyFollowing,
      receiveMessage,
      notifyPostLike,
      notifyPostComment,
      notifyFollow,
      notifyMention,
      notifyGiftReceived,
      notifyChat,
      country,
      countryCode,
      region,
      city,
      lat,
      lon,
      isFollowing,
      followStatus,
      isBlocked,
      createdAt,
      updatedAt,
      appLastUsedAt
    )
  }

  public fun <T : Any> getCurrentUser(mapper: (
    id: Long,
    firebaseUid: String,
    identity: String,
    fullname: String,
    username: String,
    email: String?,
    profilePhoto: String?,
    bio: String?,
    followerCount: Long,
    followingCount: Long,
    totalPostLikesCount: Long,
    coinWallet: Long,
    coinCollectedLifetime: Long,
    coinGiftedLifetime: Long,
    coinPurchasedLifetime: Long,
    isVerified: Long,
    isFreeze: Long,
    isReadOnly: Long,
    isModerator: Long,
    appLanguage: String,
    whoCanViewPost: Long,
    showMyFollowing: Long,
    receiveMessage: Long,
    notifyPostLike: Long,
    notifyPostComment: Long,
    notifyFollow: Long,
    notifyMention: Long,
    notifyGiftReceived: Long,
    notifyChat: Long,
    country: String?,
    countryCode: String?,
    region: String?,
    city: String?,
    lat: Double?,
    lon: Double?,
    isFollowing: Long,
    followStatus: Long,
    isBlocked: Long,
    createdAt: String,
    updatedAt: String,
    appLastUsedAt: String?,
  ) -> T): Query<T> = Query(-1_506_359_022, arrayOf("UserEntity"), driver, "User.sq",
      "getCurrentUser",
      "SELECT UserEntity.id, UserEntity.firebaseUid, UserEntity.identity, UserEntity.fullname, UserEntity.username, UserEntity.email, UserEntity.profilePhoto, UserEntity.bio, UserEntity.followerCount, UserEntity.followingCount, UserEntity.totalPostLikesCount, UserEntity.coinWallet, UserEntity.coinCollectedLifetime, UserEntity.coinGiftedLifetime, UserEntity.coinPurchasedLifetime, UserEntity.isVerified, UserEntity.isFreeze, UserEntity.isReadOnly, UserEntity.isModerator, UserEntity.appLanguage, UserEntity.whoCanViewPost, UserEntity.showMyFollowing, UserEntity.receiveMessage, UserEntity.notifyPostLike, UserEntity.notifyPostComment, UserEntity.notifyFollow, UserEntity.notifyMention, UserEntity.notifyGiftReceived, UserEntity.notifyChat, UserEntity.country, UserEntity.countryCode, UserEntity.region, UserEntity.city, UserEntity.lat, UserEntity.lon, UserEntity.isFollowing, UserEntity.followStatus, UserEntity.isBlocked, UserEntity.createdAt, UserEntity.updatedAt, UserEntity.appLastUsedAt FROM UserEntity LIMIT 1") {
      cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15)!!,
      cursor.getLong(16)!!,
      cursor.getLong(17)!!,
      cursor.getLong(18)!!,
      cursor.getString(19)!!,
      cursor.getLong(20)!!,
      cursor.getLong(21)!!,
      cursor.getLong(22)!!,
      cursor.getLong(23)!!,
      cursor.getLong(24)!!,
      cursor.getLong(25)!!,
      cursor.getLong(26)!!,
      cursor.getLong(27)!!,
      cursor.getLong(28)!!,
      cursor.getString(29),
      cursor.getString(30),
      cursor.getString(31),
      cursor.getString(32),
      cursor.getDouble(33),
      cursor.getDouble(34),
      cursor.getLong(35)!!,
      cursor.getLong(36)!!,
      cursor.getLong(37)!!,
      cursor.getString(38)!!,
      cursor.getString(39)!!,
      cursor.getString(40)
    )
  }

  public fun getCurrentUser(): Query<UserEntity> = getCurrentUser { id, firebaseUid, identity,
      fullname, username, email, profilePhoto, bio, followerCount, followingCount,
      totalPostLikesCount, coinWallet, coinCollectedLifetime, coinGiftedLifetime,
      coinPurchasedLifetime, isVerified, isFreeze, isReadOnly, isModerator, appLanguage,
      whoCanViewPost, showMyFollowing, receiveMessage, notifyPostLike, notifyPostComment,
      notifyFollow, notifyMention, notifyGiftReceived, notifyChat, country, countryCode, region,
      city, lat, lon, isFollowing, followStatus, isBlocked, createdAt, updatedAt, appLastUsedAt ->
    UserEntity(
      id,
      firebaseUid,
      identity,
      fullname,
      username,
      email,
      profilePhoto,
      bio,
      followerCount,
      followingCount,
      totalPostLikesCount,
      coinWallet,
      coinCollectedLifetime,
      coinGiftedLifetime,
      coinPurchasedLifetime,
      isVerified,
      isFreeze,
      isReadOnly,
      isModerator,
      appLanguage,
      whoCanViewPost,
      showMyFollowing,
      receiveMessage,
      notifyPostLike,
      notifyPostComment,
      notifyFollow,
      notifyMention,
      notifyGiftReceived,
      notifyChat,
      country,
      countryCode,
      region,
      city,
      lat,
      lon,
      isFollowing,
      followStatus,
      isBlocked,
      createdAt,
      updatedAt,
      appLastUsedAt
    )
  }

  public fun <T : Any> getAllUsers(mapper: (
    id: Long,
    firebaseUid: String,
    identity: String,
    fullname: String,
    username: String,
    email: String?,
    profilePhoto: String?,
    bio: String?,
    followerCount: Long,
    followingCount: Long,
    totalPostLikesCount: Long,
    coinWallet: Long,
    coinCollectedLifetime: Long,
    coinGiftedLifetime: Long,
    coinPurchasedLifetime: Long,
    isVerified: Long,
    isFreeze: Long,
    isReadOnly: Long,
    isModerator: Long,
    appLanguage: String,
    whoCanViewPost: Long,
    showMyFollowing: Long,
    receiveMessage: Long,
    notifyPostLike: Long,
    notifyPostComment: Long,
    notifyFollow: Long,
    notifyMention: Long,
    notifyGiftReceived: Long,
    notifyChat: Long,
    country: String?,
    countryCode: String?,
    region: String?,
    city: String?,
    lat: Double?,
    lon: Double?,
    isFollowing: Long,
    followStatus: Long,
    isBlocked: Long,
    createdAt: String,
    updatedAt: String,
    appLastUsedAt: String?,
  ) -> T): Query<T> = Query(-89_026_695, arrayOf("UserEntity"), driver, "User.sq", "getAllUsers",
      "SELECT UserEntity.id, UserEntity.firebaseUid, UserEntity.identity, UserEntity.fullname, UserEntity.username, UserEntity.email, UserEntity.profilePhoto, UserEntity.bio, UserEntity.followerCount, UserEntity.followingCount, UserEntity.totalPostLikesCount, UserEntity.coinWallet, UserEntity.coinCollectedLifetime, UserEntity.coinGiftedLifetime, UserEntity.coinPurchasedLifetime, UserEntity.isVerified, UserEntity.isFreeze, UserEntity.isReadOnly, UserEntity.isModerator, UserEntity.appLanguage, UserEntity.whoCanViewPost, UserEntity.showMyFollowing, UserEntity.receiveMessage, UserEntity.notifyPostLike, UserEntity.notifyPostComment, UserEntity.notifyFollow, UserEntity.notifyMention, UserEntity.notifyGiftReceived, UserEntity.notifyChat, UserEntity.country, UserEntity.countryCode, UserEntity.region, UserEntity.city, UserEntity.lat, UserEntity.lon, UserEntity.isFollowing, UserEntity.followStatus, UserEntity.isBlocked, UserEntity.createdAt, UserEntity.updatedAt, UserEntity.appLastUsedAt FROM UserEntity") {
      cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getString(6),
      cursor.getString(7),
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15)!!,
      cursor.getLong(16)!!,
      cursor.getLong(17)!!,
      cursor.getLong(18)!!,
      cursor.getString(19)!!,
      cursor.getLong(20)!!,
      cursor.getLong(21)!!,
      cursor.getLong(22)!!,
      cursor.getLong(23)!!,
      cursor.getLong(24)!!,
      cursor.getLong(25)!!,
      cursor.getLong(26)!!,
      cursor.getLong(27)!!,
      cursor.getLong(28)!!,
      cursor.getString(29),
      cursor.getString(30),
      cursor.getString(31),
      cursor.getString(32),
      cursor.getDouble(33),
      cursor.getDouble(34),
      cursor.getLong(35)!!,
      cursor.getLong(36)!!,
      cursor.getLong(37)!!,
      cursor.getString(38)!!,
      cursor.getString(39)!!,
      cursor.getString(40)
    )
  }

  public fun getAllUsers(): Query<UserEntity> = getAllUsers { id, firebaseUid, identity, fullname,
      username, email, profilePhoto, bio, followerCount, followingCount, totalPostLikesCount,
      coinWallet, coinCollectedLifetime, coinGiftedLifetime, coinPurchasedLifetime, isVerified,
      isFreeze, isReadOnly, isModerator, appLanguage, whoCanViewPost, showMyFollowing,
      receiveMessage, notifyPostLike, notifyPostComment, notifyFollow, notifyMention,
      notifyGiftReceived, notifyChat, country, countryCode, region, city, lat, lon, isFollowing,
      followStatus, isBlocked, createdAt, updatedAt, appLastUsedAt ->
    UserEntity(
      id,
      firebaseUid,
      identity,
      fullname,
      username,
      email,
      profilePhoto,
      bio,
      followerCount,
      followingCount,
      totalPostLikesCount,
      coinWallet,
      coinCollectedLifetime,
      coinGiftedLifetime,
      coinPurchasedLifetime,
      isVerified,
      isFreeze,
      isReadOnly,
      isModerator,
      appLanguage,
      whoCanViewPost,
      showMyFollowing,
      receiveMessage,
      notifyPostLike,
      notifyPostComment,
      notifyFollow,
      notifyMention,
      notifyGiftReceived,
      notifyChat,
      country,
      countryCode,
      region,
      city,
      lat,
      lon,
      isFollowing,
      followStatus,
      isBlocked,
      createdAt,
      updatedAt,
      appLastUsedAt
    )
  }

  /**
   * @return The number of rows updated.
   */
  public fun insertUser(UserEntity: UserEntity): QueryResult<Long> {
    val result = driver.execute(-685_426_296,
        """INSERT OR REPLACE INTO UserEntity (id, firebaseUid, identity, fullname, username, email, profilePhoto, bio, followerCount, followingCount, totalPostLikesCount, coinWallet, coinCollectedLifetime, coinGiftedLifetime, coinPurchasedLifetime, isVerified, isFreeze, isReadOnly, isModerator, appLanguage, whoCanViewPost, showMyFollowing, receiveMessage, notifyPostLike, notifyPostComment, notifyFollow, notifyMention, notifyGiftReceived, notifyChat, country, countryCode, region, city, lat, lon, isFollowing, followStatus, isBlocked, createdAt, updatedAt, appLastUsedAt) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)""",
        41) {
          bindLong(0, UserEntity.id)
          bindString(1, UserEntity.firebaseUid)
          bindString(2, UserEntity.identity)
          bindString(3, UserEntity.fullname)
          bindString(4, UserEntity.username)
          bindString(5, UserEntity.email)
          bindString(6, UserEntity.profilePhoto)
          bindString(7, UserEntity.bio)
          bindLong(8, UserEntity.followerCount)
          bindLong(9, UserEntity.followingCount)
          bindLong(10, UserEntity.totalPostLikesCount)
          bindLong(11, UserEntity.coinWallet)
          bindLong(12, UserEntity.coinCollectedLifetime)
          bindLong(13, UserEntity.coinGiftedLifetime)
          bindLong(14, UserEntity.coinPurchasedLifetime)
          bindLong(15, UserEntity.isVerified)
          bindLong(16, UserEntity.isFreeze)
          bindLong(17, UserEntity.isReadOnly)
          bindLong(18, UserEntity.isModerator)
          bindString(19, UserEntity.appLanguage)
          bindLong(20, UserEntity.whoCanViewPost)
          bindLong(21, UserEntity.showMyFollowing)
          bindLong(22, UserEntity.receiveMessage)
          bindLong(23, UserEntity.notifyPostLike)
          bindLong(24, UserEntity.notifyPostComment)
          bindLong(25, UserEntity.notifyFollow)
          bindLong(26, UserEntity.notifyMention)
          bindLong(27, UserEntity.notifyGiftReceived)
          bindLong(28, UserEntity.notifyChat)
          bindString(29, UserEntity.country)
          bindString(30, UserEntity.countryCode)
          bindString(31, UserEntity.region)
          bindString(32, UserEntity.city)
          bindDouble(33, UserEntity.lat)
          bindDouble(34, UserEntity.lon)
          bindLong(35, UserEntity.isFollowing)
          bindLong(36, UserEntity.followStatus)
          bindLong(37, UserEntity.isBlocked)
          bindString(38, UserEntity.createdAt)
          bindString(39, UserEntity.updatedAt)
          bindString(40, UserEntity.appLastUsedAt)
        }
    notifyQueries(-685_426_296) { emit ->
      emit("UserEntity")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun updateUser(
    fullname: String,
    username: String,
    bio: String?,
    profilePhoto: String?,
    id: Long,
  ): QueryResult<Long> {
    val result = driver.execute(-1_947_523_176, """
        |UPDATE UserEntity SET
        |    fullname = ?,
        |    username = ?,
        |    bio = ?,
        |    profilePhoto = ?
        |WHERE id = ?
        """.trimMargin(), 5) {
          bindString(0, fullname)
          bindString(1, username)
          bindString(2, bio)
          bindString(3, profilePhoto)
          bindLong(4, id)
        }
    notifyQueries(-1_947_523_176) { emit ->
      emit("UserEntity")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun deleteAllUsers(): QueryResult<Long> {
    val result = driver.execute(-1_731_340_010, """DELETE FROM UserEntity""", 0)
    notifyQueries(-1_731_340_010) { emit ->
      emit("PostEntity")
      emit("UserEntity")
    }
    return result
  }

  private inner class GetUserByIdQuery<out T : Any>(
    public val id: Long,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("UserEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("UserEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-2_145_030_961,
        """SELECT UserEntity.id, UserEntity.firebaseUid, UserEntity.identity, UserEntity.fullname, UserEntity.username, UserEntity.email, UserEntity.profilePhoto, UserEntity.bio, UserEntity.followerCount, UserEntity.followingCount, UserEntity.totalPostLikesCount, UserEntity.coinWallet, UserEntity.coinCollectedLifetime, UserEntity.coinGiftedLifetime, UserEntity.coinPurchasedLifetime, UserEntity.isVerified, UserEntity.isFreeze, UserEntity.isReadOnly, UserEntity.isModerator, UserEntity.appLanguage, UserEntity.whoCanViewPost, UserEntity.showMyFollowing, UserEntity.receiveMessage, UserEntity.notifyPostLike, UserEntity.notifyPostComment, UserEntity.notifyFollow, UserEntity.notifyMention, UserEntity.notifyGiftReceived, UserEntity.notifyChat, UserEntity.country, UserEntity.countryCode, UserEntity.region, UserEntity.city, UserEntity.lat, UserEntity.lon, UserEntity.isFollowing, UserEntity.followStatus, UserEntity.isBlocked, UserEntity.createdAt, UserEntity.updatedAt, UserEntity.appLastUsedAt FROM UserEntity WHERE id = ?""",
        mapper, 1) {
      bindLong(0, id)
    }

    override fun toString(): String = "User.sq:getUserById"
  }
}
